import { MostSearchedResultType, SearchType } from '@/types/most-search-type';

export const mostSearchesTestData: MostSearchedResultType[] = [
  {
    type: SearchType.PRESENTIAL_CONSULTATION,
    procedures: [
      {
        id: '734e0857-61ac-4d49-91b2-faba67f27993',
        type: SearchType.PRESENTIAL_CONSULTATION,
        displayName: 'Oftalmologista',
        name: 'Consulta em consultório - Oftalmologia',
        code: '10101012 - 225265',
        slug: 'consulta-em-consultorio-oftalmologia',
      },
      {
        id: 'df67d3c1-2d16-4f2e-9374-4b1e6750d0d4',
        type: SearchType.PRESENTIAL_CONSULTATION,
        displayName: 'Clínico Geral',
        name: 'Consulta em consultório - Clínico Geral ou Clínica Médica',
        code: '10101012 - 225125',
        slug: 'consulta-em-consultorio-clinico-geral-ou-clinica-medica',
      },
      {
        id: 'd92ce8ac-8dc7-4bf4-84d9-44a77534f631',
        type: SearchType.PRESENTIAL_CONSULTATION,
        displayName: 'Dermatologista',
        name: 'Consulta em consultório - Dermatologia',
        code: '10101012 - 225135',
        slug: 'consulta-em-consultorio-dermatologia',
      },
      {
        id: 'f2919250-eca8-46a5-b6bb-db905a4bf990',
        type: SearchType.PRESENTIAL_CONSULTATION,
        name: 'Consulta Psiquiatra (Psiquiatria)',
        displayName: 'Psiquiatra',
        code: '10101012 - 225133',
        slug: 'consulta-em-consultorio-psiquiatria',
      },
      {
        id: 'e14d2eb6-e68c-4508-89dd-894e7912b0ca',
        type: SearchType.PRESENTIAL_CONSULTATION,
        displayName: 'Ginecologista',
        name: 'Consulta Ginecologista (Ginecologia)',
        code: '10000761',
        slug: 'consulta-em-consultorio-ginecologista-ginecologia',
      },
      {
        id: 'ec3ec2aa-68f1-4472-8e7e-b9911864eb34',
        type: SearchType.PRESENTIAL_CONSULTATION,
        displayName: 'Psicólogo',
        name: 'Consulta em psicologia',
        code: '50000462',
        slug: 'consulta-em-psicologia',
      },
      {
        id: '46a46dd2-eb67-41d7-b6cb-e597dc5b614f',
        type: SearchType.PRESENTIAL_CONSULTATION,
        displayName: 'Cardiologista',
        name: 'Consulta Cardiologia com Eletrocardiograma',
        code: '10000003',
        slug: 'consulta-cardiologia-com-eletrocardiograma',
      },
      {
        id: 'dc617552-8fc8-434b-8f70-d78045905a3c',
        type: SearchType.PRESENTIAL_CONSULTATION,
        displayName: 'Ortopedista',
        name: 'Consulta em consultório - Ortopedia e Traumatologia',
        code: '10101012 - 225270',
        slug: 'consulta-em-consultorio-ortopedia-e-traumatologia',
      },
      {
        id: '2e1fd3be-57aa-407c-b0ab-2f7d4310e807',
        type: SearchType.PRESENTIAL_CONSULTATION,
        displayName: 'Geriatra',
        name: 'Consulta em consultório - Geriatria',
        code: '10101012 - 225180',
        slug: 'consulta-em-consultorio-geriatria',
      },
    ],
  },
  {
    type: SearchType.ONLINE_CONSULTATION,
    procedures: [
      {
        id: 'b7f79abb-370d-47ca-9ca4-c44608efdd64',
        type: SearchType.ONLINE_CONSULTATION,
        displayName: 'Teleconsulta - Clínico Geral ou Clínica Médica',
        name: 'Consulta em consultório - Clínico Geral ou Clínica Médica Online',
        code: '10002064',
        slug: 'telemedicina-clinico-geral-ou-clinica-medica',
      },
      {
        id: '6e788167-b036-433d-9ffb-336161ec307b',
        type: SearchType.ONLINE_CONSULTATION,
        displayName: 'Teleconsulta - Psicólogo',
        name: 'Consulta em psicologia Online',
        code: '50000463',
        slug: 'consulta-online-em-psicologia',
      },
      {
        id: 'de5d0053-8852-4ad7-8a72-4e355f04ea75',
        type: SearchType.ONLINE_CONSULTATION,
        displayName: 'Teleconsulta - Cardiologista',
        name: 'Consulta em consultório - Cardiologia Online',
        code: '10101012 - 225120',
        slug: 'consulta-em-consultorio-cardiologia-online',
      },
      {
        id: 'b5037ada-6f3a-44f8-81ae-7186782feee3',
        type: SearchType.ONLINE_CONSULTATION,
        displayName: 'Teleconsulta - Nutricionista',
        name: 'Consulta Nutricionista Online',
        code: '50000561',
        slug: 'consulta-nutricionista-online',
      },
      {
        id: 'ccea9a43-b6eb-423a-9855-f220d912a4ef',
        type: SearchType.ONLINE_CONSULTATION,
        displayName: 'Teleconsulta - Ginecologista',
        name: 'Consulta em consultório - Ginecologia e Obstetrícia Online e Presencial',
        code: '10101012 - 225250',
        slug: 'consulta-online-com-ginecologista-ginecologia-telemedicina',
      },
      {
        id: '477924f2-747f-49cd-b765-674c4765d920',
        type: SearchType.ONLINE_CONSULTATION,
        displayName: 'Teleconsulta - Dermatologista',
        name: 'Consulta em consultório - Dermatologia Online',
        code: '90101012',
        slug: 'consulta-em-consultorio-dermatologia-online',
      },
      {
        id: 'a9f16b4a-4297-487c-bfe2-11120bf34fa4',
        type: SearchType.ONLINE_CONSULTATION,
        displayName: 'Teleconsulta - Geneticista',
        name: 'Consulta em consultório - Genética Online',
        code: '01010101',
        slug: 'consulta-em-consultorio-genetica-online',
      },
      {
        id: '6d7259cf-cb93-4dc1-a202-aa499e5a6af5',
        type: SearchType.ONLINE_CONSULTATION,
        displayName: 'Teleconsulta - Fonoaudiologista',
        name: 'Consulta em consultório - Fonoaudiologia Online',
        code: '10000099 - 999999',
        slug: 'consulta-em-consultorio-fonoaudiologia-online-160fcae44fa0b8958098514862d06ed6',
      },
      {
        id: '50013699-57f1-4cf3-8277-c672e37eba4c',
        type: SearchType.ONLINE_CONSULTATION,
        displayName: 'Teleconsulta - Endocrinologista',
        name: 'Consulta em consultório - Endocrinologia Online',
        code: '10101778',
        slug: 'consulta-em-consultorio-endocrinologia-online-621d5db87ff02cc398fa0beede2c1a94',
      },
    ],
  },
  {
    type: SearchType.LABORATORIAL_EXAM,
    procedures: [
      {
        id: '830d1c0f-d12e-4c5b-9911-a7e3258b43f1',
        type: SearchType.LABORATORIAL_EXAM,
        displayName:
          'Hemograma meu amigo se algum procedimento tiver um nome maior que o desse hemograma ai lascou porque agora vamos limitar para 256 o nome desse procedimento ta gigante assim apenas para testar espero que entendam hahaha hihihi eh melhor se segurarem porque a jiripoca vai piar. Hemograma meu amigo se algum procedimento tiver um nome maior que o desse hemograma ai lascou porque agora vamos limitar para 256 o nome desse procedimento ta gigante assim apenas para testar espero que entendam hahaha hihihi eh melhor se segurarem porque a jiripoca vai piar',
        name: 'Hemograma',
        code: '40304361',
        slug: 'hemograma-meu-amigo-se-algum-procedimento-tiver-um-nome-maior-que-o-desse-hemograma-ai-lascou-porque-agora-vamos-limitar-para-256-o-nome-desse-procedimento-ta-gigante-assim-apenas-para-testar-espero-que-entendam-hahaha-hihihi-eh-melhor-se-segurarem-porque-a-jiripoca-vai-piar-hemograma-meu-amigo-se-algum-procedimento-tiver-um-nome-maior-que-o-desse-hemograma-ai-lascou-porque-agora-vamos-limitar-para-256-o-nome-desse-procedimento-ta-gigante-assim-apenas-para-testar-espero-que-entendam-hahaha-hihihi-eh-melhor-se-segurarem-porque-a-jiripoca-vai-piar',
      },
      {
        id: '1c1d182e-eeab-428b-ba74-53387893a8c3',
        type: SearchType.LABORATORIAL_EXAM,
        displayName: 'TSH',
        name: 'Tireoestimulante, hormônio (TSH) - pesquisa e/ou dosagem',
        code: '40316521',
        slug: 'tireoestimulante-hormonio-tsh-pesquisa-e-ou-dosagem',
      },
      {
        id: '27c126fe-53f8-4f1a-ba31-499def929a82',
        type: SearchType.LABORATORIAL_EXAM,
        displayName: 'Creatinina',
        name: 'Creatina - pesquisa e/ou dosagem',
        code: '40301630',
        slug: 'creatina-pesquisa-e-ou-dosagem',
      },
      {
        id: '1aa8da19-6aa7-4160-ad2a-cb757bfaa2ea',
        type: SearchType.LABORATORIAL_EXAM,
        displayName: 'Lipidograma',
        name: 'Perfil lipídico / lipidograma (lípidios totais, colesterol, triglicerídios e eletroforese lipoproteínas) - pesquisa e/ou dosagem',
        code: '40302750',
        slug: 'perfil-lipidico-lipidograma-lipidios-totais-colesterol-trigliceridios-e-eletroforese-lipoproteinas-pesquisa-e-ou-dosagem',
      },
      {
        id: '85a9ad2c-2599-49ca-b9db-a40b261847c5',
        type: SearchType.LABORATORIAL_EXAM,
        displayName: 'Colesterol total',
        name: 'Colesterol total - pesquisa e/ou dosagem',
        code: '40301605',
        slug: 'colesterol-total-pesquisa-e-ou-dosagem',
      },
      {
        id: 'beec3d65-affb-4bea-b09b-69dfe2966d7e',
        type: SearchType.LABORATORIAL_EXAM,
        displayName: 'Androstonediol',
        name: '3 alfa androstonediol glucoronídeo (3ALFDADIOL) - pesquisa e/ou dosagem',
        code: '40316025',
        slug: '3-alfa-androstonediol-glucoronideo-3alfdadiol-pesquisa-e-ou-dosagem',
      },
      {
        id: 'f49056f5-7769-436d-af14-491ab9dec7fe',
        type: SearchType.LABORATORIAL_EXAM,
        displayName: 'Hexanodiona',
        name: '2,5-hexanodiona, dosagem na urina',
        code: '40311236',
        slug: '2-5-hexanodiona-dosagem-na-urina',
      },
      {
        id: 'c19ed8c2-26a6-4539-8719-6ee54dc0c927',
        type: SearchType.LABORATORIAL_EXAM,
        displayName: 'Acetaminofen',
        name: 'Acetaminofen - pesquisa e/ou dosagem',
        code: '40301036',
        slug: 'acetaminofen-pesquisa-e-ou-dosagem',
      },
      {
        id: '6a7c142b-6bba-4fab-a4fd-f367f4e41ba6',
        type: SearchType.LABORATORIAL_EXAM,
        displayName: 'SARS-CoV-2',
        name: 'SARS-CoV-2 (CORONAVÍRUS COVID-19) - PESQUISA POR RT - PCR',
        code: '40314618',
        slug: 'sars-cov-2-coronavirus-covid-19-pesquisa-por-rt-pcr',
      },
    ],
  },
  {
    type: SearchType.IMAGE_EXAM,
    procedures: [
      {
        id: 'de319066-fe80-4834-ae3f-002ac48017ba',
        code: '40805026',
        name: 'Raio X Tórax 2 Incidências (AP + PERFIL)',
        displayName: 'Radiografia Tórax',
        slug: 'raio-x-torax-2-incidencias-ap-perfil-',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: '85d32525-e9b0-4096-b3a7-7f0fe6a4cd51',
        code: '40901769',
        name: 'Ultrassonografia ou Ecografia',
        displayName: 'Ecografia Aparelho Urinário',
        slug: 'ecografia-aparelho-urinario-rins-ureteres-e-bexiga-',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: 'dde09218-e555-4806-9f26-269859de1649',
        code: '10000233',
        name: 'Ultrassonografia ou Ecografia Transvaginal (USG)',
        displayName: 'Ecografia Transvaginal',
        slug: 'ecografia-transvaginal-com-doppler',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: 'e0493183-e3cf-4a23-8785-761f21001e63',
        code: '40804054',
        name: 'Raio X Joelho 2 Incidências (AP - LAT)',
        displayName: 'Raio X Joelho',
        slug: 'raio-x-joelho',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: 'dca15293-1d01-41f5-ab55-f29ac9fd8575',
        code: '41001079',
        name: 'Tomografia de Tórax ou Arcos Costais',
        displayName: 'Tomografia de Tórax',
        slug: 'tomografia-torax-com-ou-sem-contraste-',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: '0cb03c3a-ff55-41b9-8700-b6c6e2ccdd47',
        code: '40808025',
        name: 'Raio X Abdome agudo',
        displayName: 'Raio X Abdome',
        slug: 'raio-x-abdome-agudo',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: 'e9b30c3b-9d6d-4d21-8aea-33ec15d843d5',
        code: '40804011',
        name: 'Raio X Bacia (Quadril)',
        displayName: 'Raio X Bacia',
        slug: 'raio-x-bacia-quadril-',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: 'e10b67a0-1268-4908-a321-cc3a57dd0207',
        code: '40803082',
        name: 'Raio X  Braço',
        displayName: 'Raio X  Braço',
        slug: 'raio-x-braco',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: 'b226ca57-2c0e-466f-bccc-9400241304de',
        code: '40803040',
        name: 'Raio X Clavícula',
        displayName: 'Raio X Clavícula',
        slug: 'raio-x-clavicula',
        type: SearchType.IMAGE_EXAM,
      },
    ],
  },
];
